export default "__VITE_ASSET__Ds1jHIdp__ 400w, __VITE_ASSET__CP7juqOy__ 800w, __VITE_ASSET__BLSat60b__ 1024w";